import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep7 = (state) => state.get('step7');

const makeSelectStep7 = () => createSelector(
  selectStep7,
  (step7State) => ({
    claimForDamagedLostOrStolenLuggageTravelDocumentOrCash: mapWithDefault(step7State, () => step7State.getIn(['form', 'claimForDamagedLostOrStolenLuggageTravelDocumentOrCash']), ''),
    claimForDelayLuggage: mapWithDefault(step7State, () => step7State.getIn(['form', 'claimForDelayLuggage']), ''),
    claimForPassportCreditCard: mapWithDefault(step7State, () => step7State.getIn(['form', 'claimForPassportCreditCard']), ''),
    claimForTheftOfCash: mapWithDefault(step7State, () => step7State.getIn(['form', 'claimForTheftOfCash']), ''),
    claimForLuggageAndPersonalEffect: mapWithDefault(step7State, () => step7State.getIn(['form', 'claimForLuggageAndPersonalEffect']), ''),
    howItHappened: mapWithDefault(step7State, () => step7State.getIn(['form', 'howItHappened']), ''),
    whereYouWereInRelationToTheItem: mapWithDefault(step7State, () => step7State.getIn(['form', 'whereYouWereInRelationToTheItem']), ''),
    additional: mapWithDefault(step7State, () => step7State.getIn(['form', 'additional']), ''),
    claimingFor: mapWithDefault(step7State, () => step7State.getIn(['form', 'claimingFor']).toJS(), ''),
    whoDidYouReportThisTo: mapWithDefault(step7State, () => step7State.getIn(['form', 'whoDidYouReportThisTo']), ''),
    otherDescription: mapWithDefault(step7State, () => step7State.getIn(['form', 'otherDescription']), ''),
    reportReferenceNumber: mapWithDefault(step7State, () => step7State.getIn(['form', 'reportReferenceNumber']), ''),
    nameOfTransportProvider: mapWithDefault(step7State, () => step7State.getIn(['form', 'nameOfTransportProvider']), ''),
    dateLuggageDelay: mapWithDefault(step7State, () => step7State.getIn(['form', 'dateLuggageDelay']), ''),
    timeLuggageDelay: mapWithDefault(step7State, () => step7State.getIn(['form', 'timeLuggageDelay']), ''),
    dateLuggageReturn: mapWithDefault(step7State, () => step7State.getIn(['form', 'dateLuggageReturn']), ''),
    timeLuggageReturn: mapWithDefault(step7State, () => step7State.getIn(['form', 'timeLuggageReturn']), ''),
    paidForDelay: mapWithDefault(step7State, () => step7State.getIn(['form', 'paidForDelay']), ''),
    madeClaimWithTravelProviderOrOther: mapWithDefault(step7State, () => step7State.getIn(['form', 'madeClaimWithTravelProviderOrOther']), ''),
    listedOnThePolicy: mapWithDefault(step7State, () => step7State.getIn(['form', 'listedOnThePolicy']), ''),
    descriptionOfItem: mapWithDefault(step7State, () => step7State.getIn(['form', 'descriptionOfItem']), ''),
    datePurchased: mapWithDefault(step7State, () => step7State.getIn(['form', 'datePurchased']), ''),
    storeWhereItemWasPurchased: mapWithDefault(step7State, () => step7State.getIn(['form', 'storeWhereItemWasPurchased']), ''),
    purchasePrice: mapWithDefault(step7State, () => step7State.getIn(['form', 'purchasePrice']), ''),
    currency: mapWithDefault(step7State, () => step7State.getIn(['form', 'currency']), ''),
    amountClaimed: mapWithDefault(step7State, () => step7State.getIn(['form', 'amountClaimed']), ''),
    proofOfPurchaseAttached: mapWithDefault(step7State, () => step7State.getIn(['form', 'proofOfPurchaseAttached']), ''),
    additionalItems: mapWithDefault(step7State, () => step7State.getIn(['form', 'additionalItems']).toJS(), ''),
    delayedLuggageExpenses: mapWithDefault(step7State, () => step7State.getIn(['form', 'delayedLuggageExpenses']).toJS(), ''),
    dateCompensationWasReceived: mapWithDefault(step7State, () => step7State.getIn(['form', 'dateCompensationWasReceived']), ''),
    compensationDescription: mapWithDefault(step7State, () => step7State.getIn(['form', 'compensationDescription']), ''),
    amountOfCompensation: mapWithDefault(step7State, () => step7State.getIn(['form', 'amountOfCompensation']), ''),
    amountOfCompensationCurrency: mapWithDefault(step7State, () => step7State.getIn(['form', 'amountOfCompensationCurrency']), ''),
  })
);

const makeSelectStep7Errors = () =>
  createSelector(selectStep7, (state) => state.get('errors'));

export {
  makeSelectStep7,
  makeSelectStep7Errors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step7/selectors.js